import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,{staticClass:"mb-4 pa-0",attrs:{"subheader":""}},[_c(VListItem,{staticClass:"v-list-item--active list_style",staticStyle:{"background-color":"#fff"}},[_c(VIcon,{staticStyle:{"padding-top":"1px"},attrs:{"color":"rgba(111, 111, 111, 0.75)"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c(VListItemContent,{staticClass:"pl-2"},[_c(VListItemTitle,[_vm._v(_vm._s(_vm.title))])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }